import {useEffect, useRef, useState} from 'react';

import {useTranslation} from '/provider/TranslationProvider';
import {generateCallback} from '/util/component.util';

export const useReferralProfile = ({hasProfile, fetchData}: any) => {
  const {tt} = useTranslation('screen.ReferralProfile');

  useEffect(() => {
    if (!hasProfile) {
      fetchData();
    }
  }, [hasProfile, fetchData]);

  return {tt};
};

export function useRefresh(refreshCachedMetrics: () => Promise<any>) {
  const [refreshing, setRefreshing] = useState(false);

  const onRefreshRef = useRef(() => {
    setRefreshing(true);
    refreshCachedMetrics().then(
      generateCallback({func: setRefreshing, params: false}),
    );
  });

  return {refreshing, onRefreshRef: onRefreshRef.current};
}
